import { SearchOutlined } from '@ant-design/icons';
import { Input, Form, List, Row, Col, AutoComplete } from 'antd';

import React, { useState } from 'react';

function SearchStationPendingTab({
  stations,
  handleChange,
  redirectInfo,
  onClose,
  onSubmit,
  project,
}) {
  const [form] = Form.useForm();
  const [text, setText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedStation, setSelectedStation] = useState('');
  const [isStationBlank, setIsStationBlank] = useState(false);
  const [projectWorkOrder, setProjectWorder] = useState(
    project.workOrder?.split(',').map((wo) => wo.trim())
  );
  // let projectWorkOrder = project.workOrder?.split(',')
  function onTextChanged(e) {
    let value = e.target.value;
    let suggests = [];
    if (value.length > 0) {
      value = value.replace(/[^\w\s]/gi, '');
      const regex = new RegExp(`^${value}`, 'i');
      suggests = stations.sort().filter((station) => regex.test(station));
    }
    setSuggestions(suggests);
    setText(value);
    if (!value) {
      setIsStationBlank(true);
    } else {
      setIsStationBlank(false);
    }
  }

  function suggestionSelected(suggestion) {
    setText(suggestion);
    setSuggestions([]);
    setSelectedStation(suggestion);
    form.setFieldsValue({
      stationName: suggestion,
      // bpid: project.bpid,
    });
    // handleChange(suggestion);
    setIsStationBlank(false);
  }

  function renderProject() {
    if (suggestions.length === 0 || text === '') {
      return null;
    }
    return (
      <List className='list-style search-station-name' style={{ width: '80%' ,fontWeight:'lighter' }}>
        {suggestions.map((suggestion, index) => (
          <List.Item
            className='list-item'
            onClick={() => suggestionSelected(suggestion)}
            key={suggestion + index}
          >
            {suggestion}
          </List.Item>
        ))}
      </List>
    );
  }
  const onSelectOrChange = (value, field) => {
    form.setFieldsValue({
      field: value,
    });
  };
  
  return (
    <>
      <Form
        form={form}
        labelCol={{
          span: 10,
        }}
        wrapperCol={{
          span: 14,
        }}
        style={{ padding: '1rem 1rem' }}
        onFinish={(values) => onSubmit(values, onClose ,redirectInfo)}
      >
        <div style={{ top: 15, position: 'relative' }}>
          <Row justify='center' align='middle'>
            <Col sm={24} style={{ alignItems: 'end' }}>
              <Form.Item
                label='IPS Station Name:'
                name='stationName'
                initialValue={project.stationName}
                labelCol={{ span: 5 }}
                style={{fontWeight:'bolder'}}
                
              >
                <Col>
                  <Input
                    id={'addStation'}
                    autoComplete='off'
                    disabled={project.trackerStatus === 'FMP_P'}
                    value={text}
                    onChange={onTextChanged}
                    type='text'
                    allowClear
                    status='error'
                    size='small'
                    style={{
                      height: 35,
                      display: 'flex',
                      alignItems: 'center',
                      overflow: 'hidden',
                    }}
                    // style={{ width: '100%' }}
                    placeholder='Search Station Name'
                    prefix={
                      <SearchOutlined
                        id='search-icon'
                        style={{
                          color:text && selectedStation ? 'rgb(0, 150, 251)' : '',
                        }}
                      />
                    }
                    // onFocus={() => {
                    //   setSuggestions(stations.slice(0, 10));
                    // }}
                    // onBlur={()=> setSuggestions([])}
                  />
                  <span className={'stationNameDropdown '}>
                    {renderProject()}
                  </span>
                  {/* </Col> */}
                </Col>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label='BPID' name='bpid' initialValue={project.bpid ? project.bpid : project.id?.bpid} style={{fontWeight:'bolder'}}>
                <Input
                  defaultValue={project.bpid ? project.bpid : project.id?.bpid}
                  disabled={true}
                  style={{ height: 32, width: '80%' }}
                />
              </Form.Item>
            </Col>
             {project.trackerStatus === 'FMP_P' ?<Col span={12}></Col> :
            <Col span={12}>
              <Form.Item label='Removal BPID' name='removalBPID'
                              style={{fontWeight:'bolder'}}

              >
                <Input style={{ height: 32, width: '80%' }} />
              </Form.Item>
            </Col>
            }
          </Row>
          <Row>
             {project.trackerStatus === 'FMP_P' ?
             <Col span={12}>
             <Form.Item label='Work Order' name='workOrder' initialValue={project.workOrder} style={{fontWeight:'bolder'}}>
                <Input
                  defaultValue={project.workOrder}
                  disabled={true}
                  style={{ height: 32, width: '80%' }}
                />
              </Form.Item>
             </Col> 
             :
              <Col span={12}>
                <Form.Item
                  label='Work Order'
                  name='workOrder'
                  style={{fontWeight:'bolder'}}

                  initialValue={
                    projectWorkOrder && projectWorkOrder?.length === 1
                      ? project.workOrder
                      : ''
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Please enter  Work Order!',
                    },
                    {
                      max: 9,
                      message: 'Work Order Should be  9 character',
                    },
                    {
                      min: 8,
                      message: 'Work Order Should be  9 character',
                    },
                  ]}
                >
                  <AutoComplete
                    dataSource={
                      projectWorkOrder && projectWorkOrder?.length > 1
                        ? projectWorkOrder
                        : []
                    }
                    style={{ height: 32, width: '80%', fontSize: '14px' }}
                    onSelect={(value) => onSelectOrChange(value, 'workOrder')}
                    onChange={(value) => onSelectOrChange(value, 'workOrder')}
                    defaultValue={
                      projectWorkOrder && projectWorkOrder?.length === 1
                        ? project.workOrder
                        : ''
                    }
                  />
                </Form.Item>
              </Col>
            }
            {project.trackerStatus === 'FMP_P' ? <Col span={12}></Col>:
            <Col span={12}>
              <Form.Item label='Removal Work Order' name='removalWO'
                              style={{fontWeight:'bolder'}}

              >
               
                <AutoComplete
                  dataSource={projectWorkOrder && projectWorkOrder}
                  
                  style={{ height: 32, width: '80%', fontSize: '14px' }}
                  onSelect={(value) => onSelectOrChange(value, 'removalWO')}
                  onChange={(value) => onSelectOrChange(value, 'removalWO')}
                  
                />
              </Form.Item>
            </Col>
            }
            
          </Row>
        </div>
       

        <div className='btn start-2'>
          <button
            className='btn btn-primary start-5'
            htmlType='submit'
            type='submit'
            disabled={text && !stations.includes(text)}
          >
            Yes/Save
          </button>
          <button className='btn btn-primary start-5' onClick={onClose}>
            Cancel
          </button>{' '}
        </div>
      </Form>
    </>
  );
}

export default SearchStationPendingTab;